"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 14.892a.5.5 0 0 0 .978.148c1.133-3.332 3.952-4.033 6.119-4.033v-1c-2.618 0-4.676.924-5.984 2.645C1.638 7.863 4.034 5.714 9 5.372a.5.5 0 0 0 .466-.5v-2.55l5.329 5.366-5.329 5.368V9.798a.5.5 0 0 0-1 0v4.471a.499.499 0 0 0 .855.352l6.534-6.58a.502.502 0 0 0 0-.705L9.321.756a.5.5 0 0 0-.855.352v3.303C2.616 4.967 0 8.218 0 14.892Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 22.51a.563.563 0 0 0 1.1.166c1.767-5.198 6.153-6.29 9.523-6.29v-1.124c-3.118 0-7.023.851-9.382 4.516C2.122 9.97 7.875 8.18 13.511 7.79a.562.562 0 0 0 .524-.561V2.854l8.61 8.671-8.61 8.67v-5.452a.563.563 0 0 0-1.125 0v6.817a.562.562 0 0 0 .962.397l9.965-10.036a.56.56 0 0 0 0-.792L13.872 1.093a.562.562 0 0 0-.962.397v5.22C6.785 7.23 0 9.657 0 22.51Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 30.014a.75.75 0 0 0 1.466.222c2.355-6.932 8.204-8.387 12.697-8.387v-1.5c-4.157 0-9.363 1.135-12.508 6.021C2.83 13.295 10.5 10.907 18.015 10.388a.75.75 0 0 0 .698-.748V3.806l11.48 11.56-11.48 11.562v-7.271a.75.75 0 0 0-1.5 0v9.09a.75.75 0 0 0 1.283.529l13.286-13.381a.748.748 0 0 0 0-1.056L18.496 1.458a.75.75 0 0 0-1.283.529v6.959C9.047 9.64 0 12.878 0 30.014Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.113 44.516a.938.938 0 0 0 1.829.291c3.576-10.555 12.466-12.77 19.294-12.77v-1.875c-6.39 0-14.443 1.797-19.08 9.654 1.53-20.522 13.317-24.23 24.864-25.026a.939.939 0 0 0 .873-.936V4.611l17.736 17.862-17.736 17.862V28.929a.937.937 0 1 0-1.875 0v13.68a.94.94 0 0 0 1.602.661l19.995-20.137a.937.937 0 0 0 0-1.32L27.62 1.676a.938.938 0 0 0-1.602.66v10.648C13.765 13.994.113 18.761.113 44.516Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.15 59.355a1.25 1.25 0 0 0 2.44.383c4.77-14.069 16.62-17.023 25.724-17.023v-2.5c-8.52 0-19.257 2.396-25.44 12.873C4.913 25.725 20.63 20.78 36.025 19.719a1.252 1.252 0 0 0 1.164-1.247V6.149l23.648 23.816L37.19 53.78V38.57a1.25 1.25 0 1 0-2.5 0v18.242a1.251 1.251 0 0 0 2.137.881l26.66-26.85a1.25 1.25 0 0 0 0-1.76l-26.66-26.85a1.251 1.251 0 0 0-2.137.882v14.197C18.353 18.659.15 25.014.15 59.353Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconShare = function IconShare(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Share' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Share"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconShare.sizes = [16, 24, 32, 48, 64];
IconShare.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconShare;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Share.js
// module id = 1853
// module chunks = 0